export default __webpack_public_path__ + "static/media/EGG.936ffc69.png";